import React from 'react'
import RoutesComponent from '../../routes/Routes'

function App() {
	const path = window.location.toString().split('/')[3]


	return (
		path != 'events' ? <div className="App d-flex flex-column min-vh-100">
			<RoutesComponent />
		</div> : ''
	)
}

export default App
